import { api, fileApi } from '../../services/api';
import { forceFileDownload } from '../../helpers/forceFileDownload';

export type ExtratoStatus =
  | 'entregue'
  | 'nao_entregue'
  | 'sem_movimento'
  | 'em_conferencia'
  | 'pendente'
  | 'aberto'
  | 'futuro'
  | 'fora';

export interface ExtratoFile {
  id: number;
  competence: string;
  bank: string | null;
  name: string;
  size: number;
  checked: boolean;
  created_at: string;
}

export interface ExtratoMonth {
  competence: string; // YYYY-MM
  status: ExtratoStatus;
  note: string | null;
  files_count: number;
  unchecked_count: number;
  files: ExtratoFile[];
}

export interface ExtratoYear {
  year: number;
  notice: string;
  deadline_day: number | null;
  banks: string[];
  months: ExtratoMonth[];
}

export const STATUS_LABELS: Record<ExtratoStatus, string> = {
  entregue: 'Entregue',
  nao_entregue: 'Não entregue',
  sem_movimento: 'Sem movimento',
  em_conferencia: 'Em conferência',
  pendente: 'Aguardando envio',
  aberto: 'Mês em andamento',
  futuro: '—',
  fora: '—',
};

export const getExtratoYear = async (year: number): Promise<ExtratoYear> => {
  const response = await api.get('/customer/extrato-bancario', { params: { year } });
  return response.data.data;
};

export const uploadExtratos = async (
  competence: string,
  files: File[],
  bank: string,
  onProgress?: (percent: number) => void
): Promise<ExtratoFile[]> => {
  const form = new FormData();
  files.forEach((file) => form.append('files[]', file));
  if (bank) {
    form.append('bank', bank);
  }

  const response = await api.post(`/customer/extrato-bancario/${competence}/arquivos`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    // PDFs grandes em internet lenta passam dos 30s padrão
    timeout: 120000,
    onUploadProgress: (event: ProgressEvent) => {
      if (onProgress && event.total) {
        onProgress(Math.round((event.loaded * 100) / event.total));
      }
    },
  });

  return response.data.data;
};

export const deleteExtrato = async (id: number): Promise<void> => {
  await api.delete(`/customer/extrato-bancario/arquivos/${id}`);
};

export const downloadExtrato = async (file: ExtratoFile): Promise<boolean> => {
  const response = await fileApi.get(`/customer/extrato-bancario/arquivos/${file.id}`, {
    responseType: 'blob',
  });

  return forceFileDownload({ file: response.data, type: 'application/pdf', filename: file.name });
};
